import { API_Data_Localize_Response } from "@/interfaces/api/localize/api_response_types"
import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { fetcher } from "@/utils/helpers"

/**
 * Retrieves the localization of the user
 * 
 * @returns A country code
 * @throws {API_Error} If the request fails or the response is invalid.
 */
export async function getLocalize(): Promise<API_Data_Localize_Response> {
  const res = await fetcher(`/api/localize`, {
    method: 'GET'
  })
  const response = await res.json() as API_Response<API_Data_Localize_Response>
    
  if (!res.ok) throw { code: res.status, description: 'Unknown localization error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Localization data missing in response' } as API_Error

  return response.data
}